var Afghanistan = "Afghanistan";
var Albania = "Albania";
var Algeria = "Algeria";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Nam Cực";
var Argentina = "Argentina";
var Armenia = "Armenia";
var Aruba = "Aruba";
var Australia = "Úc";
var Austria = "Áo";
var Azerbaijan = "Azerbaijan";
var Bahamas = "Bahamas";
var Bahrain = "Bahrain";
var Bangladesh = "Bangladesh";
var Barbados = "Barbados";
var Belarus = "Belarus";
var Belgium = "Bỉ";
var Belize = "Belize";
var Benin = "Benin";
var Bermuda = "Bermuda";
var Bhutan = "Bhutan";
var Bolivia = "Bolivia";
var Botswana = "Botswana";
var Brazil = "Brazil";
var Bulgaria = "Bulgari";
var Burundi = "Burundi";
var Cambodia = "Campuchia";
var Cameroon = "Cameroon";
var Canada = "Canada";
var Chad = "Chad";
var Chile = "Chile";
var China = "Trung Quốc";
var Colombia = "Colombia";
var Comoros = "Comoros";
var Congo = "Congo";
var Croatia = "Croatia";
var Cuba = "Cuba";
var Cyprus = "Cộng hòa Síp";
var Denmark = "Đan Mạch";
var Djibouti = "Djibouti";
var Dominica = "Dominica";
var Ecuador = "Ecuador";
var Egypt = "Ai Cập";
var Eritrea = "Eritrea";
var Estonia = "Estonia";
var Ethiopia = "Ethiopia";
var Fiji = "Fiji";
var Finland = "Phần Lan";
var France = "Pháp";
var Gabon = "Gabon";
var Gambia = "Gambia";
var Georgia = "Georgia";
var Germany = "Đức";
var Ghana = "Ghana";
var Gibraltar = "Gibraltar";
var Greece = "Hy Lạp";
var Greenland = "Greenland";
var Grenada = "Grenada";
var Guadeloupe = "Guadeloupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernsey";
var Guinea = "Guinea";
var Guyana = "Guyana";
var Haiti = "Haiti";
var Honduras = "Honduras";
var Hungary = "Hungary";
var Iceland = "Iceland";
var India = "Ấn Độ";
var Indonesia = "Indonesia";
var Iraq = "Iraq";
var Ireland = "Ai-len";
var Israel = "Israel";
var Italy = "Ý";
var Jamaica = "Jamaica";
var Japan = "Nhật Bản";
var Jersey = "Jersey";
var Jordan = "Jordan";
var Kazakhstan = "Kazakhstan";
var Kenya = "Kenya";
var Kiribati = "Kiribati";
var Kuwait = "Kuwait";
var Kyrgyzstan = "Kyrgyzstan";
var Latvia = "Latvia";
var Lebanon = "Liban";
var Lesotho = "Lesotho";
var Liberia = "Liberia";
var Libya = "Cộng hòa Ả Rập Libya";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Lithuania";
var Luxembourg = "Luxembourg";
var Macao = "Macao";
var Madagascar = "Madagascar";
var Malawi = "Malawi";
var Malaysia = "Malaysia";
var Maldives = "Maldives";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinique";
var Mauritania = "Mauritania";
var Mauritius = "Mauritius";
var Mayotte = "Mayotte";
var Mexico = "Mexico";
var Monaco = "Monaco";
var Mongolia = "Mông Cổ";
var Montenegro = "Montenegro";
var Montserrat = "Montserrat";
var Morocco = "Maroc";
var Mozambique = "Mozambique";
var Myanmar = "Myanmar";
var Namibia = "Namibia";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Hà Lan";
var Nicaragua = "Nicaragua";
var Niger = "Niger";
var Nigeria = "Nigeria";
var Niue = "Niue";
var Norway = "Na Uy";
var Oman = "Oman";
var Pakistan = "Pakistan";
var Palau = "Palau";
var Panama = "Panama";
var Paraguay = "Paraguay";
var Peru = "Peru";
var Philippines = "Philippines";
var Pitcairn = "Pitcairn";
var Poland = "Ba Lan";
var Portugal = "Bồ Đào Nha";
var Qatar = "Qatar";
var Romania = "Romania";
var Rwanda = "Rwanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Serbia";
var Seychelles = "Seychelles";
var Singapore = "Singapore";
var Slovakia = "Slovakia";
var Slovenia = "Slovenia";
var Somalia = "Somalia";
var Spain = "Tây Ban Nha";
var Sudan = "Sudan";
var Suriname = "Suriname";
var Swaziland = "Swaziland";
var Sweden = "Thụy Điển";
var Switzerland = "Thụy Sĩ";
var Taiwan = "Đài Loan";
var Tajikistan = "Tajikistan";
var Thailand = "Thái Lan";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunisia";
var Turkey = "Thổ Nhĩ Kỳ";
var Turkmenistan = "Turkmenistan";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ukraina";
var Uruguay = "Uruguay";
var Uzbekistan = "Uzbekistan";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Yemen";
var Zambia = "Zambia";
var Zimbabwe = "Zimbabwe";
var countries = {
	"Country or region": "Quốc gia hoặc khu vực",
	"United States": "Hoa Kỳ",
	Afghanistan: Afghanistan,
	"Åland Islands": "Quần đảo Aland",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "American Samoa",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua và Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosnia và Herzegovina",
	Botswana: Botswana,
	"Bouvet Island": "Đảo Bouvet",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Lãnh thổ Ấn Độ Dương thuộc Anh",
	"Brunei Darussalam": "Brunei Darussalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Cape Verde",
	"Cayman Islands": "Quần đảo Cayman",
	"Central African Republic": "Cộng hòa Trung Phi",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Đảo Christmas",
	"Cocos (Keeling) Islands": "Quần đảo Cocos (Keeling)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Cộng hòa Dân chủ Congo",
	"Cook Islands": "Quần đảo Cook",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Bờ Biển Ngà",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "Cộng hòa Séc",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "Cộng hòa Dominica",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Guinea Xích Đạo",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Quần đảo Falkland (Malvinas)",
	"Faroe Islands": "Quần đảo Faroe",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Guiana thuộc Pháp",
	"French Polynesia": "Polynesia thuộc Pháp",
	"French Southern Territories": "Lãnh thổ phía Nam của Pháp",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinea-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Đảo Heard và Quần đảo Mcdonald",
	"Holy See (Vatican City State)": "Holy See (Thành Vatican)",
	Honduras: Honduras,
	"Hong Kong": "Hồng Kông",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Cộng hòa Hồi giáo Iran",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Đảo Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Cộng hòa Dân chủ Nhân dân Triều Tiên",
	"Korea, Republic of": "Đại Hàn Dân Quốc",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Cộng hòa Dân chủ Nhân dân Lào",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Cộng hòa Macedonia trực thuộc Nam Tư cũ",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Quần đảo Marshall",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Liên bang Micronesia",
	"Moldova, Republic of": "Cộng hòa Moldova",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Antilles thuộc Hà Lan",
	"New Caledonia": "New Caledonia",
	"New Zealand": "New Zealand",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Đảo Norfolk",
	"Northern Mariana Islands": "Quần đảo Bắc Mariana",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Lãnh thổ Palestine, Bị chiếm đóng",
	Panama: Panama,
	"Papua New Guinea": "Papua New Guinea",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Puerto Rico",
	Qatar: Qatar,
	"Réunion": "Réunion",
	Romania: Romania,
	"Russian Federation": "Liên bang Nga",
	Rwanda: Rwanda,
	"Saint Helena": "Saint Helena",
	"Saint Kitts and Nevis": "Saint Kitts và Nevis",
	"Saint Lucia": "Saint Lucia",
	"Saint Pierre and Miquelon": "Saint Pierre và Miquelon",
	"Saint Vincent and The Grenadines": "Saint Vincent và Grenadines",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "Sao Tome và Principe",
	"Saudi Arabia": "Ả Rập Xê Út",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leone",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Quần đảo Solomon",
	Somalia: Somalia,
	"South Africa": "Nam Phi",
	"South Georgia and The South Sandwich Islands": "Nam Georgia và Quần đảo Nam Sandwich",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard và Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "Cộng hòa Ả rập Syria",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Cộng hòa Thống nhất Tanzania",
	Thailand: Thailand,
	"Timor-Leste": "Đông Timor",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad và Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Quần đảo Turks và Caicos",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Các Tiểu Vương quốc Ả rập Thống nhất",
	"United Kingdom": "Vương quốc Anh",
	"United States Minor Outlying Islands": "Các tiểu đảo xa của Hoa Kỳ",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Việt Nam",
	"Virgin Islands, British": "Quần đảo Virgin, Anh",
	"Virgin Islands, U.S.": "Quần đảo Virgin, Hoa Kỳ",
	"Wallis and Futuna": "Wallis và Futuna",
	"Western Sahara": "Tây Sahara",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
